import { Call, Location } from '../../assets/icons';
import React from 'react';

export const FloatingCallButton =  ({
                                                                        phoneNumber,
  location
                                                                      }) => {
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleLocation = () => {
   window.open(location, '_blank');
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:hidden">
      <div className="flex justify-between">
        <button
          onClick={handleCall}
          className="w-[280px] h-[60px] bg-green-500 hover:bg-green-600 text-white font-semibold  rounded-lg shadow-lg flex items-center justify-center gap-3 transition-colors duration-200"
        >
          <Call className="w-7 h-7 text-white" />
          <span>Sună la autoservice</span>
        </button>
        <button
          onClick={handleLocation}
          className="p-2 w-[65px] h-[60px] bg-blue-500 rounded-lg text-white flex flex-col items-center justify-center"
        >
          <Location className="w-8 h-8" />
          <p>Locația</p>
        </button>
      </div>
    </div>
  );


};